<script setup>
import { useExtensionCardProvide } from "@/composables/useExtensionCardProvideInject";
import {computed} from "vue";


const props = defineProps({
    extension: {
        type: Object,
        default: () => ({})
    },
    settings: {
        type: Object,
        default: () => ({})
    },
});

const extensionComputed = computed(() => {
    return props.extension
})
useExtensionCardProvide(extensionComputed)


</script>

<template>
    <div class="redesign-extension-card">
        <div>
            <slot name="header"></slot>
        </div>
        <div>
            <slot name="body"></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.redesign-extension-card {
    background: var(--mainBgColor-color);
}
</style>
